module.exports = __webpack_public_path__ + "svg/dice-black.svg?69bbd361ceba9020f4d28c1e09da2ac4";